import { useState, useEffect, useCallback } from "react";
import axios from "./axios";

export const useAiQuota = () => {
  const [quota, setQuota] = useState({
    limit: 15,
    used: 0,
    remaining: 15,
    resetAt: null,
    secondsUntilReset: 0,
  });
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [countdownText, setCountdownText] = useState("");

  const fetchQuota = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get("/ask-fameo/quota");
      if (data?.status && data?.quota) {
        setQuota(data.quota);
        if (data.history) {
          setHistory(data.history);
        }
      }
    } catch (err) {
      console.error("Failed to fetch AI quota:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchQuota();
  }, [fetchQuota]);

  // Live countdown timer updater
  useEffect(() => {
    if (!quota.resetAt || quota.remaining > 0) {
      setCountdownText("");
      return;
    }

    const updateTimer = () => {
      const now = new Date().getTime();
      const resetTime = new Date(quota.resetAt).getTime();
      const diff = resetTime - now;

      if (diff <= 0) {
        setCountdownText("Resetting now...");
        fetchQuota(); // Automatically refresh quota once window expires
      } else {
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        setCountdownText(
          `${hours.toString().padStart(2, "0")}h ${minutes
            .toString()
            .padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`
        );
      }
    };

    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, [quota.resetAt, quota.remaining, fetchQuota]);

  return {
    quota,
    setQuota,
    history,
    setHistory,
    loading,
    countdownText,
    fetchQuota,
    isLimitReached: quota.remaining <= 0,
  };
};
